import React from 'react';
import './App.css';
import BaseLayout from './pages/layouts/base-layouts/base-layout';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ProtectedRoute } from './pages/layouts/protected-route/protected-route';
import { UserType } from './api/types/user/user-type';

const arrRow: number[] = [1, 2, 3];
const arr: number[][] = [];
for (let i = 0; i < 10; i++) {
  arr.push(arrRow);
}
// TODO delete
const environment = process.env.NODE_ENV;
console.log('env:: ' + environment);

// Administration routes (lines 19-68)
const administrationPaths = [
  '/',
  '/home',
  '/programs',
  '/payment-services',
  '/exams',
  '/feedbacks',
  '/accounting/salaries',
  '/accounting/salaries/history',
  '/users',
  '/students',
  '/lecturers',
  '/administration',
  '/education/lectures',
  '/external-exams',
  '/reports/high-level',
  '/reports/education/attendance',
  '/reports/education/dropout',
  '/reports/education/exams',
  '/reports/education/assignments',
  '/reports/education/lectures',
  '/reports/education/students-course-status',
  '/reports/education/teaching-feedback',
  '/reports/education/elementary',
  '/reports/tuition-payments',
  '/reports/checks',
  '/reports/standing-orders',
  '/reports/bank-transfer-installments',
  '/reports/finance/students-financial',
  '/reports/finance/courses-exceeding-hours',
  '/reports/finance/real-estate-comparison',
  '/reports/finance/courses-duration-expanded',
  '/reports/finance/course-financial-branch-breakdown',
  '/reports/finance/program-revenue-between-branches',
  '/settings/studies',
  '/settings/students',
  '/settings/lectures',
  '/settings/users',
  '/settings/operation',
  '/settings/docs',
  '/settings/branch-and-classes',
  '/settings/branch-and-classes/branches',
  '/settings/branch-and-classes/branches/:branchId/buildings',
  '/settings/branch-and-classes/branches/:branchId/buildings/:buildingId/classes',
  '/settings/buildings',
  '/settings/buildings/:buildingId/classes',
  '/settings/times',
  '/settings/professor-feedback',
  '/courses',
  '/courses-list',
  '/campuses/:branchId/programs/:programId',
  '/campuses/:branchId/programs/:programId/courses/:courseId',
];

// Professor/Lecturer routes (lines 70-75)
const lecturerPaths = [
  '/professor/lectures',
  '/professor/courses',
  '/professor/documents',
  '/professor/teaching-rates',
  '/professor/salaries',
];

// Student routes (lines 77-84)
const studentPaths = [
  '/student/programs',
  '/student/courses',
  '/student/lectures',
  '/student/assignments',
  '/student/exams',
  '/student/documents',
  '/student/payment-services',
  '/student/course-feedbacks',
  '/student/external-exams',
];

function App() {
  return (
    <SnackbarProvider>
      <div className="App">
        {environment === 'development' && (
          <div
            style={{
              position: 'fixed',
              top: '20px',
              left: '-35px',
              backgroundColor: '#ff6b35',
              color: 'white',
              padding: '8px 50px',
              fontSize: '16px',
              fontWeight: 'bold',
              zIndex: 9999,
              boxShadow: '0 3px 8px rgba(0,0,0,0.3)',
              pointerEvents: 'none',
              transform: 'rotate(-45deg)',
              transformOrigin: 'center',
            }}
          >
            DEV
          </div>
        )}
        <Router>
          <Routes>
            {/* Public routes - no protection */}
            <Route path="/login" element={<BaseLayout />} />
            <Route
              path="/clearance/feedback-page/success"
              element={<BaseLayout />}
            />
            <Route
              path="/clearance/feedback-page/failure"
              element={<BaseLayout />}
            />

            {/* Password change required - protected but accessible to all authenticated users */}
            <Route
              path="/change-password-required"
              element={
                <ProtectedRoute
                  allowedRoles={[
                    UserType.ADMINISTRATION,
                    UserType.LECTURER,
                    UserType.STUDENT,
                  ]}
                >
                  <BaseLayout />
                </ProtectedRoute>
              }
            />

            {/* Administration routes */}
            {administrationPaths.map((path, index) => (
              <Route
                key={`admin-${index}`}
                path={path}
                element={
                  <ProtectedRoute allowedRoles={[UserType.ADMINISTRATION]}>
                    <BaseLayout />
                  </ProtectedRoute>
                }
              />
            ))}

            {/* Lecturer routes */}
            {lecturerPaths.map((path, index) => (
              <Route
                key={`lecturer-${index}`}
                path={path}
                element={
                  <ProtectedRoute allowedRoles={[UserType.LECTURER]}>
                    <BaseLayout />
                  </ProtectedRoute>
                }
              />
            ))}

            {/* Student routes */}
            {studentPaths.map((path, index) => (
              <Route
                key={`student-${index}`}
                path={path}
                element={
                  <ProtectedRoute allowedRoles={[UserType.STUDENT]}>
                    <BaseLayout />
                  </ProtectedRoute>
                }
              />
            ))}

            {/* Catch-all route for unauthorized or non-existent paths */}
            <Route path="*" element={<BaseLayout showUnauthorized={true} />} />
          </Routes>
        </Router>
        <ToastContainer position={'bottom-left'} />
      </div>
    </SnackbarProvider>
  );
}

export default App;
